import { useQuery } from '@tanstack/react-query'
import { fetchDashboardSummary, fetchPilotDashboard, fetchJobRuns } from '@/services/api/dashboard'

export function useDashboardSummary() {
  return useQuery({
    queryKey: ['dashboard', 'summary'],
    queryFn: fetchDashboardSummary,
    staleTime: 30_000,
    refetchInterval: 60_000,
    retry: false,
  })
}

export function usePilotDashboard(days = 7) {
  return useQuery({
    queryKey: ['pilot-dashboard', days],
    queryFn: () => fetchPilotDashboard(days),
    staleTime: 60_000,
    refetchInterval: 120_000,
  })
}

export function useJobRuns(params: {
  page?: number
  page_size?: number
  job_code?: string
}) {
  return useQuery({
    queryKey: ['job-runs', params],
    queryFn: () => fetchJobRuns(params),
    staleTime: 30_000,
    refetchInterval: 60_000,
  })
}
